import {CtModelRouteData} from "@ctsolution/ct-framework";

export const CompanyTypeRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("companytype");
